__turbopack_context__.v({
  "closeButton": "ErrorBoundary-module__JdhosG__closeButton",
  "errorBody": "ErrorBoundary-module__JdhosG__errorBody",
  "errorBox": "ErrorBoundary-module__JdhosG__errorBox",
  "errorCode": "ErrorBoundary-module__JdhosG__errorCode",
  "errorContainer": "ErrorBoundary-module__JdhosG__errorContainer",
  "errorDetails": "ErrorBoundary-module__JdhosG__errorDetails",
  "errorHeader": "ErrorBoundary-module__JdhosG__errorHeader",
  "errorMessage": "ErrorBoundary-module__JdhosG__errorMessage",
  "errorTitle": "ErrorBoundary-module__JdhosG__errorTitle",
  "slideIn": "ErrorBoundary-module__JdhosG__slideIn",
});
